import { createContext, useContext, useRef } from "react";
import { Toast } from "primereact/toast";

type ToastContextType = {
    showToast: (options: {
        severity?: "success" | "info" | "warn" | "error";
        summary?: string;
        detail?: string;
        life?: number;
    }) => void;
};

const ToastContext = createContext<ToastContextType | null>(null);

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
    const toastRef = useRef<Toast>(null);

    const showToast = (options: any) => {
        toastRef.current?.show({
            severity: options.severity || "info",
            summary: options.summary || "",
            detail: options.detail || "",
            life: options.life || 3000
        });
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <Toast ref={toastRef} position="top-right" />
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be used within ToastProvider");
    }
    return context;
};